/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type EnumAvailabilityStatus = "available" | "booked" | "bookedByIntegrator" | "bookedByOffer" | "bookedPending" | "expired" | "offered" | "%future added value";
export type DateRangePickerAvailabilities_QueryVariables = {
    status?: EnumAvailabilityStatus | null | undefined;
    dateMin: string;
    dateMax: string;
    facility?: Array<string> | null | undefined;
    provider?: Array<string> | null | undefined;
    appointmentType?: Array<string> | null | undefined;
    includeNullApptTypes?: boolean | null | undefined;
};
export type DateRangePickerAvailabilities_QueryResponse = {
    readonly availabilitiesCountByDateArray: ReadonlyArray<number | null> | null;
};
export type DateRangePickerAvailabilities_Query = {
    readonly response: DateRangePickerAvailabilities_QueryResponse;
    readonly variables: DateRangePickerAvailabilities_QueryVariables;
};



/*
query DateRangePickerAvailabilities_Query(
  $status: EnumAvailabilityStatus
  $dateMin: String!
  $dateMax: String!
  $facility: [String!]
  $provider: [String!]
  $appointmentType: [String!]
  $includeNullApptTypes: Boolean
) {
  availabilitiesCountByDateArray(status: $status, dateMin: $dateMin, dateMax: $dateMax, appointmentType: $appointmentType, facility: $facility, provider: $provider, includeNullApptTypes: $includeNullApptTypes)
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appointmentType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateMax"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateMin"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facility"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeNullApptTypes"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "provider"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appointmentType",
        "variableName": "appointmentType"
      },
      {
        "kind": "Variable",
        "name": "dateMax",
        "variableName": "dateMax"
      },
      {
        "kind": "Variable",
        "name": "dateMin",
        "variableName": "dateMin"
      },
      {
        "kind": "Variable",
        "name": "facility",
        "variableName": "facility"
      },
      {
        "kind": "Variable",
        "name": "includeNullApptTypes",
        "variableName": "includeNullApptTypes"
      },
      {
        "kind": "Variable",
        "name": "provider",
        "variableName": "provider"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "kind": "ScalarField",
    "name": "availabilitiesCountByDateArray",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DateRangePickerAvailabilities_Query",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "DateRangePickerAvailabilities_Query",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "d35dfded704a12c0dd26d14bb4d9addc",
    "id": null,
    "metadata": {},
    "name": "DateRangePickerAvailabilities_Query",
    "operationKind": "query",
    "text": "query DateRangePickerAvailabilities_Query(\n  $status: EnumAvailabilityStatus\n  $dateMin: String!\n  $dateMax: String!\n  $facility: [String!]\n  $provider: [String!]\n  $appointmentType: [String!]\n  $includeNullApptTypes: Boolean\n) {\n  availabilitiesCountByDateArray(status: $status, dateMin: $dateMin, dateMax: $dateMax, appointmentType: $appointmentType, facility: $facility, provider: $provider, includeNullApptTypes: $includeNullApptTypes)\n}\n"
  }
};
})();
(node as any).hash = '84e0e38a2bf1e8588dabecc85fc00d8e';
export default node;
